import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  SlSpeedometer,
  SlBubbles,
  // SlCloudDownload,
  SlEnergy,
} from "react-icons/sl";
import "./sidebar.css";
import { SiAmazondynamodb } from "react-icons/si";
// import { MdOutlineCloudDone } from "react-icons/md";
import { FaBars, FaTimes } from "react-icons/fa";
import { FiBookOpen } from "react-icons/fi";
import { FiChevronsLeft } from "react-icons/fi";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
import { SiKubernetes } from "react-icons/si";
// import { LuDatabaseZap } from "react-icons/lu";


const Sidebar = ({ onToggle }) => {
    const location = useLocation();
    const provider = localStorage.getItem("provider");
    const isAzure = provider.toLocaleLowerCase() === "azure";
    const isAws = provider.toLocaleLowerCase() === "aws";
    const isGcp = provider.toLowerCase() === "gcp"

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsSidebarOpen(false); // Close sidebar for tablet view
        if (onToggle) onToggle(false); // Notify parent
      }
    };

    handleResize(); // Set initial state based on viewport size
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [onToggle]);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    if (onToggle) onToggle(!isSidebarOpen); // Notify parent/sibling about the state change
  };

  return (
    <>
      {/* Hamburger Menu */}
      <button
        className="hamburger-btn d-lg-none"
        onClick={toggleSidebar}
        aria-label="Toggle Sidebar"
      >
        {isSidebarOpen ? <FaTimes /> : <FaBars />}
      </button>
      <div
        className={`sidebar ${
          isSidebarOpen ? "sidebar-open" : "sidebar-closed"
        }`}
      >
        <div className="scrollbar-inner sidebar-wrapper">
          {/* <div className="position-absolute sidebar-button fs-3">
          <FaCircleChevronRight />
          </div> */}

          <div
            className={`${
              !isSidebarOpen
                ? ""
                : "p-0 d-flex align-items-center justify-content-between"
            }`}
          >
            {" "}
            <div
              className={`px-3 py-2 mt-2 ms-2 fs-6 fw-bold ${
                !isSidebarOpen ? "" : "logobottom"
              }`}
            >
              <Link to="/dashboard" className="logo text-white">
                <h5> {isSidebarOpen ? "Disaster Recovery" : ""}</h5>
              </Link>
            </div>
            <FiChevronsLeft
              className={`toggle-btn text-white ms-2 fs-6 me-3 mt-2 ${
                !isSidebarOpen ? "rotate-arrow ms-4" : ""
              }`}
              onClick={toggleSidebar}
            />
          </div>
          <ul className="nav">
           { (isAzure || isAws || isGcp) && (<li
              className={`nav-item ${
                location.pathname === "/dashboard" ? "active" : ""
              }`}
            >
              <Link to="/dashboard" className="nav-link me-3 fs-7">
                <Tooltip
                  title={isSidebarOpen ? "" : "Dashboard"}
                  position="right"
                  trigger="mouseenter"
                  arrow={true}
                  disabled={isSidebarOpen}
                >
                  <SlSpeedometer className="me-2 icon fs-5" />

                  {isSidebarOpen && "Dashboard"}
                </Tooltip>
              </Link> 
            </li>)} 
            { (isAzure || isAws || isGcp) && (<li
              className={`nav-item ${
                location.pathname === "/initiatedr" ? "active" : ""
              }`}
            >
              <Link to="/initiatedr" className="nav-link me-3 fs-7">
                <Tooltip
                  title={isSidebarOpen ? "" : "Initiate DR"}
                  position="right"
                  trigger="mouseenter"
                  arrow={true}
                  disabled={isSidebarOpen}
                >
                  <SlEnergy className="me-2 icon fs-5" />
                  {isSidebarOpen && "Initiate DR"}
                </Tooltip>
              </Link>
            </li>)}
            { (isAzure) && (<li
              className={`nav-item ${
                location.pathname === "/capacity" ? "active" : ""
              }`}
            >
              <Link to="/capacity" className="nav-link me-3 fs-7">
                <Tooltip
                  title={isSidebarOpen ? "" : "Capacity Planning"}
                  position="right"
                  trigger="mouseenter"
                  arrow={true}
                  disabled={isSidebarOpen}
                >
                  <SiAmazondynamodb className="me-2 icon fs-5" />
                  {isSidebarOpen && "Capacity Planning"}
                </Tooltip> 
              </Link>
            </li>)}
          
            { (isAzure) && (<li
              className={`nav-item ${
                location.pathname === "/teams" ? "active" : ""
              }`}
            >
              <Link to="/teams" className="nav-link me-3 fs-7">
                <Tooltip
                  title={isSidebarOpen ? "" : "Teams"}
                  position="right"
                  trigger="mouseenter"
                  arrow={true}
                  disabled={isSidebarOpen}
                >
                  <SlBubbles className="me-2 icon fs-5" />
                  {isSidebarOpen && "Teams"}
                </Tooltip>
              </Link>
            </li>)}
            { (isAzure) && (<li
              className={`nav-item ${
                location.pathname === "/runbook" ? "active" : ""
              }`}
            >
              <Link to="/runbook" className="nav-link me-3 fs-7">
                <Tooltip
                  title={isSidebarOpen ? "" : "DR Run Book"}
                  position="right"
                  trigger="mouseenter"
                  arrow={true}
                  disabled={isSidebarOpen}
                >
                  <FiBookOpen className="me-2 icon fs-5" />
                  {isSidebarOpen && "DR Run Book"}
                </Tooltip>
              </Link>
            </li>)}
            <li
              className={`nav-item ${
                location.pathname === "/kubernetes" ? "active" : ""
              }`}
            >
              <Link to="/kubernetes" className="nav-link me-3 fs-7">
                <Tooltip
                  title={isSidebarOpen ? "" : "Kubernetes"}
                  position="right"
                  trigger="mouseenter"
                  arrow={true}
                  disabled={isSidebarOpen}
                >
                  <SiKubernetes className="me-2 icon fs-5" /> 
                  {isSidebarOpen && "Kubernetes"}
                </Tooltip>
              </Link>
            </li>
            {/* <li
              className={`nav-item ${
                location.pathname === "/dbbackup" ? "active" : ""
              }`}
            >
              <Link to="/dbbackup" className="nav-link me-3 fs-7">
                <Tooltip
                  title={isSidebarOpen ? "" : "DB Backup"}
                  position="right"
                  trigger="mouseenter"
                  arrow={true}
                  disabled={isSidebarOpen}
                >
                  <LuDatabaseZap className="me-2 icon fs-5" /> 
                  {isSidebarOpen && "DB Backup"}
                </Tooltip>
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
